// BlogPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import BlogPost from '../components/BlogPost'; // Adjust the import path based on your directory structure

const BlogPage = () => {
  // Retrieve the blog post ID from the URL parameters using useParams hook
  const { id } = useParams();

  return (
    <div className="min-h-screen flex flex-col bg-gray-200 pt-20 pb-20">
      <div className="container mx-auto px-6">
        {/* Render the BlogPost component with the specified ID */}
        <BlogPost id={id} />
      </div>
    </div>
  );
};

export default BlogPage;
